/**
 * Created by hp on 2017/8/4.
 */
const defaults = {
    wkSearch: {
        defaultValue: '',
        placeholder: '搜索',
        handleChange: null,
        handleSubmit: null,
        lang: {cancel: '取消'},
    },
    wkSlide: {
        options: {
            startSlide: 0,
            speed: 400,
            auto: 3000,
            continuous: true,
            disableScroll: false,
            stopPropagation: false,
        },
        content: [],
    },
    wkShowMore: {
        loading: false,
    },
    wkEvaluation: {
        evaluationAudioCount: 0,
        evaluationAudioLast: false,
        isShowEntry: true
    }
};


export default (state = defaults, action) => {
    switch (action.type) {
        case 'WK_INIT_SEARCH':
            return {...state, wkSearch: action.payload};
        case 'WK_CLEAN_SEARCH':
            return {...state, wkSearch: defaults.wkSearch};
        case 'WK_INIT_SLIDE':
            return {...state, wkSlide: {options: state.wkSlide.options, content: action.payload.content}};
        case 'WK_CLEAR_SLIDE':
            return {...state, wkSlide: {options: state.wkSlide.options, content: []}};
        case 'WK_INIT_SHOW_MORE':
            return {...state, wkShowMore: action.payload};
        case 'WK_SET_AUDIO_LISTENCOUNT':
            return {
                ...state, wkEvaluation: {
                    isShowEntry: state.wkEvaluation.isShowEntry,
                    evaluationAudioCount: state.wkEvaluation.evaluationAudioCount + 1,
                    evaluationAudioLast: state.wkEvaluation.evaluationAudioLast
                }
            }
        case 'WK_SET_IS_AUDIO_LAST':
            return {
                ...state, wkEvaluation: {
                    isShowEntry: state.wkEvaluation.isShowEntry,
                    evaluationAudioCount: state.wkEvaluation.evaluationAudioCount,
                    evaluationAudioLast: true
                }
            }
        case 'WK_HIDE_EVALUATION':
            return {
                ...state, wkEvaluation: {
                    isShowEntry: state.wkEvaluation.isShowEntry,
                    evaluationAudioCount: state.wkEvaluation.evaluationAudioCount,
                    evaluationAudioLast: false
                }
            }
        case 'WK_HIDE_EVALUATION_ENTRY':
            return {
                ...state, wkEvaluation: {
                    isShowEntry: false,
                    evaluationAudioCount: state.wkEvaluation.evaluationAudioCount,
                    evaluationAudioLast: state.wkEvaluation.evaluationAudioLast
                }
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/wk.js